(function ($) {
    $(".jlfamily-green-location-block .form-section-container .form-container .text-field input")
        .on("focus", function () {
            $(".jlfamily-green-location-block .form-section-container .form-container").toggleClass("focused"); 
        })
        .on("blur", function () {
            $(".jlfamily-green-location-block .form-section-container .form-container").toggleClass("focused");
        });

    $(".join-our-newsletter .gform-body .gform_fields .gfield--type-email input")
        .on("focus", function () {
            $(".join-our-newsletter .gform-body .gform_fields .gfield--type-email").toggleClass("focused"); 
        })
        .on("blur", function () {
            $(".join-our-newsletter .gform-body .gform_fields .gfield--type-email").toggleClass("focused");
        });
})(jQuery);